import { RootState } from "libLegacy/ducks/state";
import { hen, Hen } from "libLegacy/internal/store";
import {
  FilterDashboard,
  DashboardBillingValues,
  DashboardMonitoringValues,
  DashboardBillingChartsValue,
} from "libLegacy/api/models";

import { UNAUTHORIZED } from "./auth";
import {
  getFilterReferenceDate,
  getFilterStartEndDates,
} from "./filter_store_initializers";

export type InitialState = {
  filter: FilterDashboard;

  dashboardBillingBriefByInstID: {
    [instID: string]: DashboardBillingValues | undefined;
  };
  dashboardBillingChartByInstID: {
    [instID: string]: DashboardBillingChartsValue | undefined;
  };
  dashboardMonitoringBriefByInstID: {
    [instID: string]: DashboardMonitoringValues | undefined;
  };
  loading: { [k in keyof InitialState]?: boolean };
};

//Reducers
const { month, year } = getFilterReferenceDate();
const { periodStart, periodEnd } = getFilterStartEndDates();

const initialState: InitialState = {
  dashboardBillingBriefByInstID: {},
  dashboardBillingChartByInstID: {},
  dashboardMonitoringBriefByInstID: {},
  filter: {
    instID: "",
    month,
    year,
    periodStart,
    periodEnd,
    granularity: "daily",
  },
  loading: {},
};
class LocalSlice extends Hen<InitialState> {
  mergeFilter(f: Partial<FilterDashboard>) {
    this.state.filter = { ...this.state.filter, ...f };
  }
  billingBriefLoaded(v: DashboardBillingValues) {
    this.state.dashboardBillingBriefByInstID["billingData"] = v;
  }
  billingChartsLoaded(v: DashboardBillingChartsValue) {
    this.state.dashboardBillingChartByInstID["billingChartData"] = v;
  }
  monitoringBriefLoaded(v: DashboardMonitoringValues) {
    this.state.dashboardMonitoringBriefByInstID["monitoring"] = v;
  }
  loadingChanged(k: keyof InitialState["loading"], l: boolean) {
    this.state.loading[k] = l;
  }
}

export const [Reducer, actions] = hen(new LocalSlice(initialState), {
  [UNAUTHORIZED]: () => {
    return initialState;
  },
});

// Selectors

export const dashboardFilterSelector = (state: RootState) =>
  state.dashboard.filter;
